import React, {Component} from "react";
import 'ag-grid-enterprise';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import {AG_GRID_LOCALE_FA} from "../../Resource/Locals/ad-grid/locale.fa";
import './index.css';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {deleteGrid, updateGrid} from "../../Redux/Actions/grid";
import Resource from "../../Resource";
import * as moment from "jalali-moment";
import Notif from "../Notif";
import {default as DateInput} from "../Control/Date";
import {AgGridReact} from 'ag-grid-react';
import Tooltip from '../Tooltip';

const gridDateTime = (format = 'date_time', params) => {
    if (typeof format !== "string") {
        params = {...format};
        format = 'date_time';
    }

    if (!params.data)
        return '';

    const value = params.data[params.column.colId];

    if (value) {
        switch (format) {
            case 'date':
                return moment(value).format('jYYYY/jMM/jDD');
            case 'time':
                return moment(value).format('HH:mm');
            case 'date_time':
                return moment(value).format('HH:mm jYYYY/jMM/jDD');
            default:
                return moment(value).format('jYYYY/jMM/jDD HH:mm');
        }
    } else {
        return '-';
    }
};

const gridTextFilterConfig = {
    filter: 'agTextColumnFilter',
    filterParams: {
        filterOptions: ['contains', 'notContains'],
        suppressAndOrCondition: true
    }
};

const gridSetFilterConfig = (values = []) => {
    return {
        filter: 'agSetColumnFilter',
        filterParams: {
            values: values,
        }
    };
};

const gridDateFilterConfig = {
    filter: 'agDateColumnFilter',
    filterParams: {
        filterOptions: ['equals', 'greaterThan', 'lessThan', 'notEqual', 'inRange'],
        suppressAndOrCondition: true
    }
};

class Storage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            date: null,
            saved: Boolean(props?.agGridReact?.props?.grid[props?.agGridReact?.props?.id])
        };
    }

    render() {
        return <div className={'dis-f'} style={{width: '100%', flexDirection: 'column', flex: 1}}>
            <div className={'Storage-block'}>
                <div className={'pad-10 fb-20 dis-f'}>
                    <p className={'pad-b-10'}>برای این که تغییرات اعمال شده بعد از بستن پنجره از بین نرود و امکان سفارشی سازی جدول برای استفاده های آتی می توانید با انتخاب دکمه پایین تنظیمات جدول را ذخیره کنید.</p>
                    <button type={'button'} onClick={this.saveClickHandler.bind(this)}>ذخیره تنظیمات فعلی</button>
                </div>
            </div>
            <div className="Storage-block">
                <div className={'pad-10 fb-20 dis-f'}>
                    <p className={'pad-b-10'}>درصورت بروز مشکل یا نیاز به حذف تنظیمات ذخیره شده و بازگشت به تنظیمات پیشفرض می توانید با انتخاب دکمه پایین تنظیمات جدول رو به حالت اولیه بازگردانید.</p>
                    <button type={'button'} disabled={!this.state.saved} onClick={this.deleteClickHandler.bind(this)}>حذف تنظیمات ذخیره شده</button>
                </div>
            </div>
            {this.state.saved && <div className="Storage-block">
                <p style={{fontWeight: '500', padding: 10, color: 'var(--goo-red)'}}>تنظیمات جدول ذخیره شده</p>
            </div>}
        </div>;
    }

    deleteClickHandler() {
        const {props} = this;
        props.deleteGrid(props.id);

        new Notif('تنظیمات مربوط به جدول حذف شد.').show();

        this.setState({saved: false});
    }

    saveClickHandler() {
        const {props} = this;

        if (props.columnApi) {
            const columnState = props.columnApi?.getColumnState();
            const columnGroupState = props.columnApi?.getColumnGroupState();

            props.updateGrid(props.id, {columnState, columnGroupState});

            new Notif({message: 'تنظیمات مربوط به جدول ذخیره شد.'}).show();

            this.setState({saved: true});
        }
    }
}

class Help extends Component {
    constructor(props) {
        super(props);

        this.state = {
            date: null,
        };
    }

    render() {
        return <div className={'dis-f'} style={{width: '100%', flexDirection: 'column', flex: 1}}>
            {this.props.agGridReact.props.help ?
                this.props.agGridReact.props.help() :
                <div className={'Help-empty'}>راهنمایی برای این جدول تنظیم نشده است.</div>}
        </div>;
    }

    deleteClickHandler() {
        const {props} = this;
        props.deleteGrid(props.id);

        new Notif('تنظیمات مربوط به جدول حذف شد.').show();

        this.setState({saved: false});
    }

    saveClickHandler() {
        const {props} = this;

        if (props.columnApi) {
            const columnState = props.columnApi?.getColumnState();
            const columnGroupState = props.columnApi?.getColumnGroupState();

            props.updateGrid(props.id, {columnState, columnGroupState});

            new Notif({message: 'تنظیمات مربوط به جدول ذخیره شد.'}).show();

            this.setState({saved: true});
        }
    }
}

class GridDateInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            date: null,
            value: null,
            placeholder: props.placeholder,
            label: props.label,
            format: 'jYYYY-jMM-jDD'
        };
    }

    render() {
        const {state, props} = this;

        return <DateInput className={'GridDateInput'} placeholder={props.placeholder} value={state.value} onChange={this.onChangeHandler.bind(this)}/>;
    }

    getDate() {
        return this.state.date;
    }

    onChangeHandler(moment) {
        this.setState({
            date: !moment || (moment.format() === 'Invalid date') ? null : new Date(moment.format()),
            value: moment
        });
        this.props.onDateChanged();
    }

    onDateChanged = (selectedDates) => {
        console.log(selectedDates);
        this.setState({date: selectedDates[0]});
        this.onChangeHandler(selectedDates[0]);
    };

    setDate(date) {
        const value = date ? moment(date.toString()) : null;

        this.setState({date, value});
    }

    setInputAriaLabel(label) {
        this.setState({label});
    }

    setInputPlaceholder(placeholder) {
        this.setState({placeholder});
    }
}

class toolTip extends Component {
    render() {
        const data = this.props.api.getDisplayedRowAtIndex(this.props.rowIndex).data;

        return (
            <div className="toolTip">
                <p>
                    <span>{data.athlete}</span>
                </p>
                <p>
                    <span>Country: </span> {data.country}
                </p>
                <p>
                    <span>Total: </span> {data.total}
                </p>
            </div>
        );
    }

    getReactContainerClasses() {
        return ['toolTip'];
    }
}

class Grid extends Component {
    constructor(props) {
        super(props);
        props.refer.current = this;


        props.refer.current = this;

        this.state = {
            api: null,
            columnApi: null
        };
    }

    static defaultProps = {
        refer: {current: null},
        showFields: false,
        id: null,
        rowData: [],
        // modules: [AllModules, ClientSideRowModelModule, RangeSelectionModule],
        defaultColDef: {
            unSortIcon: true,
            sortable: true,
            editable: false,
            flex: 1,
            minWidth: 100,
            filter: true,
            resizable: true,
            floatingFilter: true,
            // enableRowGroup: true,
            // tooltipComponent: 'tooltip'
        },
        columnDefs: [],
        tooltipShowDelay: 0,
        rowSelection: 'multiple',
        groupSelectsChildren: true,
        enableRangeSelection: true,
        suppressScrollOnNewData: true,
        suppressCopyRowsToClipboard: true,
        suppressColumnVirtualisation: true,
        animateRows: true,
        enableRtl: true,
        enablePivot: true,
        multiSortKey: 'ctrl',
        statusBar: {
            statusPanels: [
                {
                    statusPanel: 'agTotalAndFilteredRowCountComponent',
                    align: 'left',
                },
                {
                    statusPanel: 'agTotalRowCountComponent',
                    align: 'center',
                },
                {statusPanel: 'agFilteredRowCountComponent'},
                {statusPanel: 'agSelectedRowCountComponent'},
                {statusPanel: 'agAggregationComponent'},
            ],
        },
        sideBar: {
            toolPanels: [{
                id: 'columns',
                labelDefault: 'Columns',
                labelKey: 'columns',
                iconKey: 'columns',
                toolPanel: 'agColumnsToolPanel',
            }, {
                id: 'filters',
                labelDefault: 'Filters',
                labelKey: 'filters',
                iconKey: 'filter',
                toolPanel: 'agFiltersToolPanel',
            }, {
                id: 'storage',
                labelDefault: 'Storage',
                labelKey: 'storage',
                iconKey: 'storage',
                toolPanel: 'storage'
            }, {
                id: 'help',
                labelDefault: 'Help',
                labelKey: 'help',
                iconKey: 'help',
                toolPanel: 'help'
            }],
            position: 'left'
        },
        frameworkComponents: {
            storage: Storage,
            help: Help,
            tooltip: toolTip,
            agDateInput: GridDateInput
        },
        icons: {
            storage: `<img src="${Resource.IMAGE.PACK.CLOUD}"/>`,
            help: `<img src="${Resource.IMAGE.PACK.IDEA}"/>`
        },
        overlayNoRowsTemplate: `<span class="Grid-error-overlay">اطلاعات جدول لود نشد...<br/>لطفا دکمه F5 را فشار دهید</span>`,
        localeText: AG_GRID_LOCALE_FA,
        style: {},
        help: _ => null,
        onGridReady: _ => null,
        onSelectionChanged: _ => null,
        onFilterChanged: _ => null
    };

    static propTypes = {
        refer: PropTypes.object,
        showFields: PropTypes.bool,
        id: PropTypes.string.isRequired,
        rowData: PropTypes.array,
        modules: PropTypes.array,
        defaultColDef: PropTypes.object,
        columnDefs: PropTypes.array,
        rowSelection: PropTypes.string,
        groupSelectsChildren: PropTypes.bool,
        enableRangeSelection: PropTypes.bool,
        animateRows: PropTypes.bool,
        enableRtl: PropTypes.bool,
        enablePivot: PropTypes.bool,
        multiSortKey: PropTypes.string,
        floatingFilter: PropTypes.bool,
        statusBar: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
        sideBar: PropTypes.object,
        localeText: PropTypes.object,
        style: PropTypes.object,
        help: PropTypes.func,
        onGridReady: PropTypes.func,
        onSelectionChanged: PropTypes.func,
        onFilterChanged: PropTypes.func
    };

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.props !== nextProps;
    }

    render() {
        const {props} = this;

        const grid = {...props};

        if (!grid.rowData?.length) {
            grid.rowData = null;
        }
        grid.sideBar.toolPanels[2].toolPanelParams = {id: props.id, updateGrid: props.updateGrid, deleteGrid: props.deleteGrid, grid: props.grid};
        if (!props.help())
            delete grid.sideBar.toolPanels[3]
        grid.frameworkComponents = {...this.constructor.defaultProps.frameworkComponents, ...props.frameworkComponents};
        grid.defaultColDef = {...this.constructor.defaultProps.defaultColDef, ...props.defaultColDef};
        delete grid.style;
        delete grid.onGridReady;
        delete grid.onSelectionChanged;
        delete grid.onFilterChanged;
        delete grid.refer;

        return <div className={`ag-theme-${props?.grid?.defaultSettings?.gridTheme}`} style={{...props.style}}>
            {props.showFields ? <div className={'fieldSet'}>{Object.keys((grid.rowData || [])[0] || {}).map((item, index) => {
                const id = item.match(/id/ig);
                return <span className={id ? 'red' : ''} key={index}>{item}</span>;
            })}</div> : null}
            <AgGridReact {...grid}
                         onGridReady={this.onGridReady.bind(this)}
                         onFirstDataRendered={this.onFirstDataRendered.bind(this)}
                         onColumnVisible={this.onSaveGridColumnState.bind(this)}
                         onColumnPinned={this.onSaveGridColumnState.bind(this)}
                         onColumnResized={this.onSaveGridColumnState.bind(this)}
                         onModelUpdated={this.onModelUpdated.bind(this)}
                         onColumnMoved={this.onSaveGridColumnState.bind(this)}
                         onColumnRowGroupChanged={this.onSaveGridColumnState.bind(this)}
                         onColumnValueChanged={this.onSaveGridColumnState.bind(this)}
                         onColumnPivotChanged={this.onSaveGridColumnState.bind(this)}
                         onSelectionChanged={this.onSelectionChangeHandler.bind(this)}
                         onFilterChanged={props.onFilterChanged}/>
        </div>;
    }

    error(message = true) {
        const {state} = this;

        if (this.state.api) {
            if (message) {
                state.api.showNoRowsOverlay(message);
            } else {
                state.api.hideOverlay();
            }
        }
    }

    loading(loading = true) {
        const {state} = this;

        if (this.state.api) {
            if (loading) {
                state.api.showLoadingOverlay();
            } else {
                state.api.hideOverlay();
            }
        }
    }

    onFirstDataRendered(params) {
        const {props} = this;
        const config = props.grid[props.id];

        params.columnApi.autoSizeAllColumns(true);
        config?.columnState && params.columnApi.setColumnState(config.columnState);
        config?.columnGroupState && params.columnApi.setColumnGroupState(config?.columnGroupState);
    }

    onGridReady(params) {
        this.setState({...params});

        // params.columnApi.autoSizeAllColumns();

        this.props.onGridReady(params);
    }

    onModelUpdated(params) {
        params.columnApi.autoSizeAllColumns(true);
    }

    onSaveGridColumnState() {
    }

    onSelectionChangeHandler() {
        this.props.onSelectionChanged(this.state.api.getSelectedRows());
    }
}

const GridControls = props => {
    return <div className={'GridControls'}>{props.children}</div>;
};

class GridButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: props.loading,
            disabled: props.disabled,
            tooltip: props.title ? new Tooltip({title: props.title}) : null
        };

        this.ref = {
            button: React.createRef()
        };
    }

    static defaultProps = {
        title: null,
        icon: null,
        type: 'button',
        theme: null,
        loading: false,
        disabled: false,
        onClick: _ => null
    };

    static propTypes = {
        title: PropTypes.string,
        icon: PropTypes.string,
        type: PropTypes.oneOf(['button', 'text']),
        theme: PropTypes.oneOf(['select', 'accept', 'print', 'add', 'edit', 'delete', 'view', 'yellow', 'blue', 'green', 'red']),
        loading: PropTypes.bool,
        disabled: PropTypes.bool,
        onClick: PropTypes.func
    };

    componentWillUnmount() {
        if (this.state.tooltip) {
            this.state.tooltip.hide();
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const {state} = this;

        return state.loading !== nextState.loading ||
            state.disabled !== nextState.disabled;
    }

    render() {
        const {props, state} = this;
        const style = {};
        const cls = ['GridButton'];

        if (props.icon && !state.loading) {
            style.backgroundImage = `url(${props.icon})`;
        }

        props.type && cls.push(props.type);
        props.theme && cls.push(props.theme);
        state.loading && cls.push('loading');
        props.icon && cls.push('icon');

        return <button ref={this.ref.button}
                       className={cls.join(' ')}
                       disabled={state.loading || state.disabled}
                       style={style}
                       onClick={this.onClickHandler.bind(this)}
                       onMouseEnter={this.onMouseEnter.bind(this)}
                       onMouseLeave={this.onMouseLeave.bind(this)}><span>{props.title}</span></button>;
    }

    disabled(state = true) {
        this.setState({disabled: state});
    }

    loading(state = true) {
        this.setState({loading: state});
    }

    onClickHandler(event) {
        event.stopPropagation();
        event.preventDefault();

        this.props.onClick({...this.props.data, ref: this, loading: this.loading.bind(this), disabled: this.disabled.bind(this)});
    }

    onMouseEnter() {
        this.state.tooltip.show({
            title: this.props.title,
            coordinates: this.ref.button.current.getBoundingClientRect()
        });
    }

    onMouseLeave() {
        this.state.tooltip.hide();
    }
}

const GridStates = props => {
    return <div className={'GridStates'}>{props.children}</div>;
};

class GridState extends Component {
    static defaultProps = {
        theme: null
    };

    static propTypes = {
        theme: PropTypes.oneOf(['yellow', 'blue', 'green', 'red'])
    };

    render() {
        const {props} = this;

        return <span className={`GridState ${props.theme}`}>{props.children}</span>;
    }
}

const mapStateToProps = state => {
    return {
        grid: state.grid
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateGrid: (name, config) => dispatch(updateGrid(name, config)),
        deleteGrid: name => dispatch(deleteGrid(name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Grid);
export {GridControls, GridButton, GridStates, GridState, gridDateTime, gridTextFilterConfig, gridSetFilterConfig, gridDateFilterConfig};